export const getInsurancesSelector = store => {
    return store.getIn(["insurances", "insurances"])
}
export const getInsurancesCountSelector = store => {
    return store.getIn(["insurances", "insurancesCount"])
}
